import useDefinedContext from "hooks/useDefinedContext";
import ChartOptionsContext from "components/charting/contexts/ChartOptionsContext";

function useChartOptions() {
  return useDefinedContext(ChartOptionsContext);
}
export default useChartOptions;
